import React from 'react';
import { Button } from './ui/button';
import { Phone, MessageCircle } from 'lucide-react';
import { contactInfo } from '../mockData';

export const CTA = ({ t }) => {
  const handleWhatsApp = () => {
    const url = `https://wa.me/91${contactInfo.phone}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`;
    window.open(url, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:+91${contactInfo.phone}`;
  };

  return (
    <section className="py-20 bg-brand-lightPink relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-brand-navy rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-pink rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl sm:text-5xl font-bold font-serif text-brand-navy mb-6">
            {t.ctaTitle}
          </h2>
          <p className="text-xl text-brand-navy/80 mb-10 font-medium">
            {t.ctaSubtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={handleCall}
              size="lg"
              className="gap-2 bg-brand-navy text-white hover:bg-brand-navy/90 text-lg px-8 py-6 shadow-xl transform transition-all duration-200 hover:scale-105 font-semibold"
            >
              <Phone className="h-5 w-5" />
              {t.ctaCall}
            </Button>
            <Button
              onClick={handleWhatsApp}
              size="lg"
              className="gap-2 bg-whatsapp hover:bg-[#1DA851] text-white text-lg px-8 py-6 shadow-xl transform transition-all duration-200 hover:scale-105 font-semibold"
            >
              <MessageCircle className="h-5 w-5" />
              {t.ctaWhatsapp}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
